// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconGeneralMapPin: React.FC<{}> = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="28" viewBox="0 0 21 28">
            <path
                fill="currentColor"
                d="M0 10.28C0 4.57 4.703 0 10.5 0S21 4.57 21 10.28c0 6.474-6.562 14.252-9.297 17.19a1.63 1.63 0 0 1-2.406 0C6.562 24.532 0 16.754 0 10.28m10.5 3.645c1.914 0 3.5-1.577 3.5-3.481s-1.586-3.481-3.5-3.481S7 8.54 7 10.443c0 1.905 1.586 3.482 3.5 3.482"
            />
        </svg>
    );
};

const svgString = `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="28"><path fill="#cd4a23" d="M0 10.28C0 4.57 4.703 0 10.5 0S21 4.57 21 10.28c0 6.474-6.562 14.252-9.297 17.19a1.63 1.63 0 0 1-2.406 0C6.562 24.532 0 16.754 0 10.28m10.5 3.645c1.914 0 3.5-1.577 3.5-3.481s-1.586-3.481-3.5-3.481S7 8.54 7 10.443c0 1.905 1.586 3.482 3.5 3.482"/></svg>`;

export const encodedIconGeneralMapPin = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgString)}`;

export default React.memo(IconGeneralMapPin);
